// extracted by mini-css-extract-plugin
module.exports = {"allJobsHeader":"AllCompanies_allJobsHeader__2uDZ5","introComapnies":"AllCompanies_introComapnies__3VieP","imageCompany":"AllCompanies_imageCompany__-7Yg7"};